import { render, staticRenderFns } from "./DocumentTemplateDetailTokenListOptionsMobile.vue?vue&type=template&id=7f245d7b&scoped=true&"
import script from "./DocumentTemplateDetailTokenListOptionsMobile.vue?vue&type=script&lang=ts&"
export * from "./DocumentTemplateDetailTokenListOptionsMobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f245d7b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlideXReverseTransition } from 'vuetify/lib/components/transitions';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
installComponents(component, {VBtn,VChip,VIcon,VSlideXReverseTransition,VSpeedDial})
